import { useRouter } from "next/router";
import InstructorApi from "@features/instructor/helpers/instructorApi";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import { useLayoutContext } from "@context/layout";

export function useInstructorPage() {
  const { isAdmin } = useLayoutContext();
  const { query } = useRouter();
  const slug = typeof query.slug === "string" ? query.slug : "";

  const request = slug ? InstructorApi.instructorDetail(slug) : null;
  const { data, error, mutate } = useRequestImmutable(request);

  return {
    slug,
    instructor: data?.data,
    error,
    mutate,
    request,
    query,
    isAdmin,
  };
}
